import React from 'react';

import { Loader as PrismUILoader } from '@nutanix-ui/prism-reactjs';
import type { LoaderProps as PrismUILoaderProps } from '@nutanix-ui/prism-reactjs/lib/components/v2/Loader/Loader';
import classnames from 'classnames';

import './Loader.scss';

export enum LoaderType {
  DEFAULT = 'default',
  LARGE = 'large',
  GRAY = 'gray',
  GRAY_LARGE = 'gray-large',
  WHITE = 'white',
  WHITE_LARGE = 'white-large',
  NAV_APPEARANCE = 'nav-appearance',
  NAV_APPEARANCE_LARGE = 'nav-appearance-large',
  NAV_APPEARANCE_GRAY = 'nav-appearance-gray',
  NAV_APPEARANCE_GRAY_LARGE = 'nav-appearance-gray-large',
}

export type LoaderProps = PrismUILoaderProps & {
  className?: string;
  type?: LoaderType;
};

const loaderClassNames = {
  [LoaderType.DEFAULT]: '',
  [LoaderType.LARGE]: '-large',
  [LoaderType.GRAY]: '-gray',
  [LoaderType.GRAY_LARGE]: '-gray -large',
  [LoaderType.WHITE]: '',
  [LoaderType.WHITE_LARGE]: '-large',
  [LoaderType.NAV_APPEARANCE]: '-navigation-inner',
  [LoaderType.NAV_APPEARANCE_LARGE]: '-navigation-inner -large',
  [LoaderType.NAV_APPEARANCE_GRAY]: '-navigation-inner -gray',
  [LoaderType.NAV_APPEARANCE_GRAY_LARGE]: '-navigation-inner -gray -large',
};

export default function Loader({
  className,
  type = LoaderType.DEFAULT,
  ...props
}: React.PropsWithChildren<LoaderProps>) {
  const classNames = classnames(className, 'loader', `loader--${type}`);
  return (
    <PrismUILoader {...props} className={classNames} loaderClassName={loaderClassNames[type]} role="progressbar" />
  );
}
